/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Use_Cases_Video_DescriptionInputs */

const en_directory_taxonomy_use_cases_video_description = /** @type {(inputs: Directory_Taxonomy_Use_Cases_Video_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore tools for generating, editing, and refining video.`)
};

const zh_directory_taxonomy_use_cases_video_description = /** @type {(inputs: Directory_Taxonomy_Use_Cases_Video_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索用于生成、编辑和优化视频的工具。`)
};

/**
* | output |
* | --- |
* | "Explore tools for generating, editing, and refining video." |
*
* @param {Directory_Taxonomy_Use_Cases_Video_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_use_cases_video_description = /** @type {((inputs?: Directory_Taxonomy_Use_Cases_Video_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Use_Cases_Video_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_use_cases_video_description(inputs)
	return zh_directory_taxonomy_use_cases_video_description(inputs)
});
export { directory_taxonomy_use_cases_video_description as "directory.taxonomy.use-cases.video.description" }